import { useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { PluginAPI as Agent, Plugins } from '../../../libs/models/app/Plugin';
import { Tag } from '../../../components/Tag';
import { Button } from '../../../components/Button';
import { DropdownHeader } from '../../../components/DropdownHeader';
import { Text } from '../../../components/base';
import { Avatar, Empty } from '../../../components/base';
import classNames from 'classnames';
import { useAppDispatch, useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import { usePlugin } from '../../../libs/hooks/usePlugin';
import { addPlugin } from '../../../redux/features/app/pluginsSlice';

interface ModelListProps {
  data: Plugins;
  selectedPluginId: string;
  searchQuery: string;
  onSelect: (id: string) => void;
  isOpen: boolean;
  setIsOpen?: (value: boolean) => void;
}
// ModelList
export const ModelList = forwardRef<{ handleKeyDown: (event: React.KeyboardEvent) => void } | null, ModelListProps>(
  ({ selectedPluginId, searchQuery, onSelect, isOpen, setIsOpen, data }, ref) => {

    const datas = Object.values(data);
    const [agentList, setAgentList] = useState<Agent[]>(datas); 
    const [hoverIndex, setHoverIndex] = useState(0);

    const  isDesktop  = useAppSelector((state:RootState) => state.app.viewType == 'Desktop');
    const listRef = useRef<HTMLUListElement | null>(null);
    const { getAgentAutocomplete } = usePlugin();
    const dispatch = useAppDispatch();
    // const debounceRef = useRef<number | undefined>(undefined);

    useEffect(() => {
      // console.log("searchQuery", searchQuery, searchQuery.length);
      
      // const filtered = searchQuery != null && searchQuery != ''
      //   ? datas.filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
      //   : datas;

      // const prevfiltered = searchQuery != null && searchQuery != ''
      // ? agentList.filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
      // : [];

      // 필터링된 리스트를 setFilteredList에 설정
      
      // const filtered = favoritedfiltered.concat(prevfiltered);

      const run = async () => {
        let agents: Agent[] = [];
        const q = (searchQuery ?? '').trim();
        // console.log("setSearchQuery 호출:", q);
        try {
          agents = await getAgentAutocomplete(q, 20);
        } catch {
          agents = [];
        }

        agents.forEach((p) => {
          if (!p.hidden) dispatch(addPlugin(p));
        });

        setAgentList(agents);
        setHoverIndex(
          selectedPluginId
            ? Math.max(agents.findIndex((item) => item.id === selectedPluginId), 0)
            : 0,
        );
      };

      if(searchQuery.trim() == null || searchQuery.trim() == '') {setAgentList(datas); return;}
      else void run();
      
      // if(filtered && filtered.length > 0 ) {
      //   setAgentList(filtered);
      //   setHoverIndex(
      //     selectedPluginId
      //       ? Math.max(
      //           // 음수가 안나오도록
      //           filtered.findIndex((item) => item.id === selectedPluginId),
      //           0,
      //         )
      //       : 0,
      //   );
      // }
      // // else debounceRef.current = window.setTimeout(() => { void run(); }, 180);
      // else void run();
      
    
    }, [searchQuery, selectedPluginId]);

    // useEffect(() => {
    //   if (debounceRef.current) {
    //     window.clearTimeout(debounceRef.current);
    //   }

    //   const run = async () => {
    //     let agents: Agent[] = [];
    //     const q = (searchQuery ?? '').trim();
    //     try {
    //       agents = await getAgentAutocomplete(q, 10);
    //     } catch {
    //       agents = [];
    //     }

    //     setAgentList(agents);
    //     setHoverIndex(
    //       selectedPluginId
    //         ? Math.max(agents.findIndex((item) => item.id === selectedPluginId), 0)
    //         : 0,
    //     );
    //   };

    //   debounceRef.current = window.setTimeout(() => { void run(); }, 180);

    //   return () => {
    //     if (debounceRef.current) {
    //       window.clearTimeout(debounceRef.current);
    //     }
    //   };
    // }, [searchQuery, selectedPluginId, agents]);

    useEffect(() => {
      const listElement = listRef.current;

      if (listElement) {
        const selectedElement = listElement.querySelector(
          `.model-list-item:nth-child(${hoverIndex + 1})`,
        ) as HTMLElement;
        selectedElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }, [hoverIndex]);

    const setClose = () => {
      if (setIsOpen) setIsOpen(false);
    };

    useImperativeHandle(ref, () => ({
      handleKeyDown(event: React.KeyboardEvent) {
        switch (event.key) {
          case 'ArrowDown':
            if (agentList.length === 0) {
              event.preventDefault();
              return;
            } setHoverIndex((prevIndex) => (prevIndex + 1) % agentList.length);
            event.preventDefault();
            break;

          case 'ArrowUp':
            if (agentList.length === 0) {
              event.preventDefault();
              return;
            } setHoverIndex((prevIndex) => (prevIndex - 1 + agentList.length) % agentList.length);
            event.preventDefault();
            break;

          case 'Enter':
            if (hoverIndex >= 0 && hoverIndex < agentList.length) {
              onSelect(agentList[hoverIndex].id);
              setClose();
              event.preventDefault();
            }
            break;

          case 'Escape':
            setClose();
            event.preventDefault();
            break;
        }
      },
    }));

    return (
      <ul ref={listRef} tabIndex={0} role="listbox" className="ds-popover" data-state={isOpen ? 'show' : 'hide'}>
        <DropdownHeader title="에이전트">
          {isDesktop ? (
            <Button
              classOnly="chat-button-edit"
              onClick={() => {
                const options =
                  'location=no,menubar=no,toolbar=yes,scrollbars=no,resizable=yes,width=1600,height=800,left=200,top=200'; // 팝업 창의 크기와 위치 및 설정
                window.open('/makers/agent', '_blank', options);
                setClose();
              }}
            >
              편집하기
            </Button>
          ) : (
            <Button className="ds-control-close" control textBlind onClick={setClose}>
              닫기
            </Button>
          )}
        </DropdownHeader>

        {agentList.length === 0 ? (
          <Empty
            image="images/ico_load.svg"
            desc={
              <>
                <Text as="strong" weight="semibold">
                  즐겨찾기한 에이전트가 없습니다
                </Text>
                <br />
                에이전트 즐겨찾기 시 빠른 활용이 가능해요
              </>
            }
          >
            {/* <Button theme="secondary" size="small"> */}
            {isDesktop && (
              <Button
                theme="secondary"
                onClick={() => {
                  const options =
                    'location=no,menubar=no,toolbar=yes,scrollbars=no,resizable=yes,width=1600,height=800,left=200,top=200'; // 팝업 창의 크기와 위치 및 설정
                  window.open('/makers/agent', '_blank', options);
                }}
              >
                에이전트 보러가기
              </Button>
            )}
          </Empty>
        ) : (
          <>
            <div className="model-list">
              {agentList
                .filter((c) => !c.hidden)
                .map((item: Agent, index) => (
                  <div
                    key={index}
                    tabIndex={0}
                    className={classNames('model-list-item', { hover: index === hoverIndex })}
                    onMouseEnter={() => { setHoverIndex(index); }}
                  >
                    <a
                      className="model-item"
                      aria-selected={item.id === selectedPluginId}
                      data-disabled={item.isAvailable ?? false}
                      // tabIndex={item.isAvailable ? undefined : -1}
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        onSelect(item.id);
                        setClose();
                      }}
                    >
                      <Avatar src={item.profileUrl} label="" />

                      <div className="title">
                        {/* {item.displayName} {item.tag && <em className="ds-tag type-notice">{item.tag}</em>} */}
                        <strong className="name">{item.name}</strong>
                        {item.tags?.map((tag, index) => (
                          <Tag key={index} type="notice" className="suffix">
                            {tag}
                          </Tag>
                        ))}
                        <span className="desc">{item.description}</span>
                      </div>
                    </a>
                  </div>
                ))}
              {!isDesktop && (
                <Text size="caption1" className="ds-text-info">
                  에이전트 목록 편집은 pc환경에서만 가능해요
                </Text>
              )}
            </div>
          </>
        )}
      </ul>
    );
  },
);

ModelList.displayName = 'ModelList';
